import { render, staticRenderFns } from "./FormPromoCodeSent.vue?vue&type=template&id=66a6ce72&scoped=true"
import script from "./FormPromoCodeSent.vue?vue&type=script&lang=js"
export * from "./FormPromoCodeSent.vue?vue&type=script&lang=js"
import style0 from "./FormPromoCodeSent.vue?vue&type=style&index=0&id=66a6ce72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6ce72",
  null
  
)

export default component.exports